<template>
  <Modal v-model="visible" title="预览" :mask-closable="false" width="1200" :footer-hide="true" class="my-modal p-b">
    <Tabs v-model="curUrl" :animated="false">
      <TabPane v-for="bean in list" :key="bean.path" :label="bean.fileName" :name="bean.path">
        <iframe :src="bean.path" frameborder="0"></iframe>
      </TabPane>
    </Tabs>
  </Modal>
</template>

<script>
export default {
  props: {
  },
  data() {
    return {
      curUrl:'',
      visible: false,
      list: [],
    };
  },
  methods: {
    // list: [{path: '', fileName: ''}],
    open(list) {
      if (!list || !list.length) return;
      this.list = list;
      this.curUrl = list[0].path;
      this.visible = true;
    }
  }
};
</script>

<style lang="scss" scoped>
iframe {
  width: 100%;
  height: 70vh;
}
</style>